"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

window.addEventListener("DOMContentLoaded", () => {});

/******************
 * PIONEER
 ******************/
gsap.fromTo(
  ".js-animation-border",
  { height: 0, autoAlpha: 0 },
  {
    height: "100%",
    autoAlpha: 1,
    delay: 0.1,
    duration: 1.2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".js-animation-trigger",
      start: "top 85%",
      end: "bottom -10",
      scrub: 2.4,
      // markers: true,
    },
  }
);
const itemAnime = document.querySelectorAll(".js-animation-item");
itemAnime.forEach((item, index) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 80%",
    once: true,
    onEnter: () => {
      item.classList.add("is-active");
    },
  });
});

/******************
 * OPNE & FLAT CULTUREのブルー背景
 ******************/

const fadeAnim = document.querySelectorAll(".business-lead__bottom");
fadeAnim.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 45%",
    once: true,
    // markers: true,
    onEnter: () => {
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(".business-lead__bg", { opacity: 1, duration: 0.8 }, 0);
    },
  });
});
